/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
// import '../../css/typography.css';

export default function Typography({ variant, text, ...rootDOMAttributes }) {
  return (
    <div {...rootDOMAttributes}>
      {variant === 'h1' && (
        <h2 className="text-3xl font-bold leading-8">{text}</h2>
      )}
      {variant === 'h2' && (
        <h3 className="text-2xl font-semibold leading-7">{text}</h3>
      )}
      {variant === 'h3' && (
        <h4 className="text-xl font-medium leading-7">{text}</h4>
      )}
      {variant === 'sub-title' && (
        <h6 className="text-text-secondary font-normal text-base">{text}</h6>
      )}
      {variant === 'accent-sm' && (
        <h6 className="text-accent text-sm font-semibold">{text}</h6>
      )}
      {variant === 'accent-md' && (
        <h6 className="text-accent text-base font-semibold">{text}</h6>
      )}
      {variant === 'accent-lg' && (
        <h6 className="text-accent text-lg font-semibold">{text}</h6>
      )}
      {variant === 'accent-xl' && (
        <h6 className="text-accent text-xl font-semibold">{text}</h6>
      )}
      {variant === 'body' && (
        <p className="text-text-primary font-normal text-sm">{text}</p>
      )}
      {variant === 'small' && (
        <p className="text-text-primary font-normal text-xs">{text}</p>
      )}
    </div>
  );
}

Typography.propTypes = {
  variant: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
